import { render, staticRenderFns } from "./wrongquestion.vue?vue&type=template&id=53876393&scoped=true"
import script from "./wrongquestion.vue?vue&type=script&lang=js"
export * from "./wrongquestion.vue?vue&type=script&lang=js"
import style0 from "./wrongquestion.vue?vue&type=style&index=0&id=53876393&prod&lang=scss&scoped=true"
import style1 from "./wrongquestion.vue?vue&type=style&index=1&id=53876393&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53876393",
  null
  
)

export default component.exports